import { render, staticRenderFns } from "./IPAddressTypeBadge.vue?vue&type=template&id=c261e83e"
import script from "./IPAddressTypeBadge.vue?vue&type=script&lang=js"
export * from "./IPAddressTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports